import React from "react";
import st from "./shippingBadge.module.scss";
import Image from "next/image";
import { getCloudflareLoader } from "@pepdirect/helpers/cloudflareImages";
import { endpoints } from "config";

// TODO: Extract to separate component with BundlePromo
export function ShippingBadge(): JSX.Element {
  return (
    <div className={st.wrapper}>
      <figure className={st.imageWrapper}>
        <Image
          loader={getCloudflareLoader(endpoints.cdn)}
          src="/static-images/pantry-shop-icons/free-ship-badge.png"
          alt="free ship badge"
          fill
          // double width for retina screens
          sizes="120px"
          style={{
            objectFit: "contain",
          }}
        />
      </figure>

      <div className={st.text}>
        <strong>Free Standard Shipping Over $20</strong> on all orders with most
        orders arriving in 2-4 business days.
      </div>
    </div>
  );
}
